// extracted by mini-css-extract-plugin
module.exports = {"box":"Nav_box__2iT_2","btn":"Nav_btn__3M3k9"};